import { Action, ThunkAction, configureStore } from '@reduxjs/toolkit';
import commonSlice from 'app/store/common.slice';
import createSagaMiddleware from 'redux-saga';
import commonSaga from 'app/store/common.saga';
import { call, all } from 'redux-saga/effects';
import { vocabularyTestReducer } from 'pages/VocabularyTest/store/vocabularyTest.slice';
import vocabularyTestSaga from 'pages/VocabularyTest/store/vocabularyTest.saga';
import { feedbackReducer } from 'features/feedback/store/feedback.slice';
import feedbackSaga from 'features/feedback/store/feedback.saga';
import { ideasReducer } from 'features/feedback/store/ideas.slice';
import ideasSaga from 'features/feedback/store/ideas.saga';
import { mineReducer } from 'features/feedback/store/mine.slice';
import mineSaga from 'features/feedback/store/mine.saga';
import { adminReducer } from 'features/feedback/store/admin.slice';
import adminSaga from 'features/feedback/store/admin.saga';

const sagaMiddleware = createSagaMiddleware();

export const store = configureStore({
  reducer: {
    common: commonSlice.reducer,
    vocabularyTest: vocabularyTestReducer,
    feedback: feedbackReducer,
    ideas: ideasReducer,
    mine: mineReducer,
    admin: adminReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(sagaMiddleware),
});

function* rootSaga() {
  yield all([
    call(commonSaga),
    call(vocabularyTestSaga),
    call(feedbackSaga),
    call(ideasSaga),
    call(mineSaga),
    call(adminSaga),
  ]);
}

sagaMiddleware.run(rootSaga);

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;
